/* eslint-disable jsx-a11y/anchor-is-valid */

import {FC} from 'react'
import {Navigate, Route, Routes} from 'react-router-dom'
import {Registration} from './sub-pages/Registration'
import {ForgotPassword} from './sub-pages/ForgotPassword'
import {Login} from './sub-pages/Login'
import {Invitation} from './sub-pages/Invitation'
import {ProfileRecoveryComp} from './sub-pages/ProfileRecoveryComp'
import {ResetPassword} from './sub-pages/ResetPassword'
import {VerifyEmail} from './sub-pages/VerifyEmail'
import PricingPlan from './sub-pages/PricingPlan'
import {SignupError} from '../errors/components/SignupError'
import DialoguePage from './sub-pages/DialoguePage'
import Plans from './sub-pages/Plans'
import Payment from './sub-pages/Payment'
import {AcceptAndRegister} from './sub-pages/AcceptAndRegister'
import {GuestRegistration} from './sub-pages/GuestRegisteration'
import { VerifyEmailChange } from './sub-pages/VerifyEmailChange'
import { VerifyOrgEmailChange } from './sub-pages/VerifyOrgEmailChange'
import AuthLayout from './AuthLayout'

const AuthPage: FC = () => {
  return (
    <Routes>
      <Route element={<AuthLayout />}>
        <Route path='login' element={<Login />} />
        <Route path='pricing-plan/:planName' element={<PricingPlan />} />
        <Route path='payment' element={<Payment />} />
        <Route path='with-plan' element={<Registration />} />
        {/* <Route path={`registration`} element={<RenderPages /> */}
        {/* } /> */}

        <Route path='/registration' element={<Registration />} />
        <Route path='/:token/registration' element={<Registration />} />
        <Route path='invite' element={<Invitation />} />
        <Route path='organization-invitation' element={<AcceptAndRegister />} />
        <Route path='/:token/guest-invitation' element={<GuestRegistration />} />
        {/* <Route path='guest-invitation' element={<AcceptAndRegister />} /> */}
        <Route path='reset-password/*' element={<ResetPassword />} />
        <Route path='profile-recovery/*' element={<ProfileRecoveryComp />} />
        <Route path='forgot-password' element={<ForgotPassword />} />
        <Route path='verify-email/*' element={<VerifyEmail />} />
        <Route path='email-change/verify' element={<VerifyEmailChange />} />
        <Route path='organization-email-change/verify' element={<VerifyOrgEmailChange />} />
        <Route path='/error/signup-error' element={<SignupError />} />
        <Route index element={<Login />} />
        <Route path='*' element={<Navigate to='/error/404' />} />
      </Route>
      <Route path='/email-verification' element={<Plans />} />
      <Route path='dialogue' element={<DialoguePage />} />
    </Routes>
  )
}

export {AuthPage}
